import React from 'react';
import UIList from '@mui/material/List';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import {
  data as commentTypes
} from '@lba-dev/package.local-globals/commentsConstants';
import Paper from '@mui/material/Paper';

const styles = {
  fontAbbr: { fontSize: '0.750rem' },
  marginBotCtr: { marginBottom: 25 },
  comment: {
    wordBreak: 'break-word',
  },
  uList: {
    padding: 0,
    margin: '0 15px',
  },
  ctnComment: {
    padding: '0 10px 12px',
  },
  paper: {
    margin: '1%',
    maxHeight: 300,
    overflow: 'auto',
  },
};

export const commentView = ({
  artisan: { comments },
  users,
  limit = null,
  type = null,
}) => {
  if (!comments) {
    return '';
  }
  if (type) {
    comments = comments.filter((e) => e.type === type);
  }
  comments = comments.sort((a, b) => new Date(b.date) - new Date(a.date));
  if (limit) {
    comments = comments.slice(0, limit);
  }
  return (
    <Paper style={styles.paper}>
      <UIList style={styles.uList}>
        {comments.map((comment) => {
          const user =
            (users.find((e) => e._id === comment.userId) || {}).login || '';
          const dateString = `${new Date(comment.date).toLocaleString(
            'fr-FR'
          )} par ${user}`;
          const type = commentTypes.find((e) => e._id === comment.type);
          return (
            <div
              key={`${comment.userId}-${comment.date}`}
              style={{
                ...styles.ctnComment,
                ...styles.fontAbbr,
              }}
            >
              <Typography style={styles.comment}>
                {comment.commentValue}
              </Typography>
              <Typography variant="caption">
                {dateString} - {type.name}
              </Typography>
              <Divider />
            </div>
          );
        })}
      </UIList>
    </Paper>
  );
};
